/* ============================================================
   AVALNA PDP CONVERSION — Batch 02b
   Bundled IIFE for all 9 conversion layer features.

   Dawn Theme Structure Notes (for future batch reference):
   ─────────────────────────────────────────────────────────
   • Variant change: Dawn uses a PubSub system (assets/pubsub.js).
     The product-info.js custom element publishes PUB_SUB_EVENTS.variantChange
     ('variant-change') with data: { sectionId, html, variant }.
     Subscribe via: subscribe(PUB_SUB_EVENTS.variantChange, callback).
     The 'variant' object in the callback has: id, price, compare_at_price, etc.
   • Product form: <product-form> custom element containing
     form[data-type="add-to-cart-form"]. Submit button has class
     .product-form__submit and id ProductSubmitButton-{sectionId}.
   • Price block: <div id="price-{sectionId}"> rendered by the 'price'
     block type in main-product.liquid (line ~109).
   • ATC button: button.product-form__submit inside <product-form>.
   • Share button: <share-button> custom element at line ~472 of
     main-product.liquid via {% render 'share-button' %}.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- NAMESPACE ---------- */
  window.Avalna = window.Avalna || {};
  window.Avalna.pdp = window.Avalna.pdp || {};
  window.Avalna.pdp.conversion = {
    delivery: {},
    urgency: {},
    stickyAtc: {},
    whatsappInquiry: {},
    whatsappShare: {},
    copyLink: {},
    savings: {}
  };

  /* ================================================================
     HELPER: Variant-change subscription
     Dawn's PUB_SUB_EVENTS.variantChange published by product-info.js
     ================================================================ */
  function avalnaSubscribeVariantChange(callback) {
    // Dawn loads constants.js (PUB_SUB_EVENTS) and pubsub.js (subscribe)
    // Both are deferred, so they should be available by DOMContentLoaded
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) {
          callback(event.data.variant);
        }
      });
      return true;
    }
    console.warn('[Avalna] PubSub not available — dynamic variant updates disabled. Dawn may have changed its API.');
    return false;
  }

  /* ================================================================
     FEATURE 3: Estimated Delivery Date (#21)
     ================================================================ */
  function avalnaInitDelivery() {
    var el = document.getElementById('avalna-pdp-delivery-dates');
    if (!el) return;

    var minDays = parseInt(el.getAttribute('data-avalna-min-days'), 10) || 5;
    var maxDays = parseInt(el.getAttribute('data-avalna-max-days'), 10) || 7;

    function avalnaAddBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var day = result.getDay();
        if (day !== 0 && day !== 6) {
          added++;
        }
      }
      return result;
    }

    function avalnaFormatDate(date) {
      return date.toLocaleDateString('en-IN', {
        month: 'short',
        day: 'numeric'
      });
    }

    var now = new Date();
    var dateMin = avalnaAddBusinessDays(now, minDays);
    var dateMax = avalnaAddBusinessDays(now, maxDays);
    el.textContent = avalnaFormatDate(dateMin) + ' – ' + avalnaFormatDate(dateMax);

    window.Avalna.pdp.conversion.delivery = {
      minDays: minDays,
      maxDays: maxDays,
      dateMin: dateMin,
      dateMax: dateMax
    };
  }

  /* ================================================================
     FEATURE 4: Stock Urgency (#22)
     ================================================================ */
  function avalnaInitUrgency() {
    var el = document.getElementById('avalna-pdp-urgency');
    if (!el) return;

    var textEl = document.getElementById('avalna-pdp-urgency-text') || el;

    var threshold = parseInt(el.getAttribute('data-avalna-threshold'), 10);
    if (isNaN(threshold)) threshold = 5;

    // Parse variant data from embedded JSON
    var dataEl = document.getElementById('avalna-pdp-variant-data');
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('[Avalna] Could not parse variant data for urgency');
      }
    }

    function avalnaUpdateUrgency(variant) {
      if (!variant) {
        el.hidden = true;
        return;
      }

      // Find variant in our data — the published variant object has id and price
      // but may not have inventory_quantity, so look it up from our JSON
      var found = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === variant.id) {
          found = variants[i];
          break;
        }
      }

      var qty = found ? found.inventory_quantity : null;
      if (qty === null || qty === undefined || qty <= 0) {
        el.hidden = true;
        return;
      }

      if (threshold > 0 && qty <= threshold) {
        textEl.textContent = 'Only ' + qty + ' left';
        el.setAttribute('data-avalna-urgency-level', 'low');
        el.hidden = false;
      } else if (qty <= 20) {
        textEl.textContent = 'In stock';
        el.setAttribute('data-avalna-urgency-level', 'ok');
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    // Initial state: use the first variant from parsed data or default
    var initialVariantId = null;
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant) {
      initialVariantId = parseInt(urlVariant, 10);
    } else if (variants.length > 0) {
      // Use the first available variant
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          initialVariantId = variants[i].id;
          break;
        }
      }
      if (!initialVariantId && variants.length > 0) {
        initialVariantId = variants[0].id;
      }
    }

    if (initialVariantId) {
      avalnaUpdateUrgency({ id: initialVariantId });
    }

    // Subscribe to variant changes
    avalnaSubscribeVariantChange(function (variant) {
      avalnaUpdateUrgency(variant);
    });

    window.Avalna.pdp.conversion.urgency = {
      update: avalnaUpdateUrgency,
      threshold: threshold
    };
  }

  /* ================================================================
     FEATURE 5: Sticky ATC Bar — Mobile Only (#23)
     ================================================================ */
  function avalnaInitStickyAtc() {
    var bar = document.getElementById('avalna-pdp-sticky-atc');
    if (!bar) return;

    var btn = bar.querySelector('.avalna-pdp-sticky-atc__btn');
    if (!btn) return;

    // Find the real ATC button
    var realBtn = document.querySelector('.product-form__submit');
    var realForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');

    // IntersectionObserver to detect when real ATC scrolls out of view
    if (realBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show sticky bar when real button is NOT visible
          bar.setAttribute('data-avalna-sticky-visible', entry.isIntersecting ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: "0px 0px -80px 0px" });

      observer.observe(realBtn);
    }

    // Sticky bar ATC click: trigger Dawn's real form submission
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (realBtn) {
        realBtn.click();
      } else if (realForm) {
        if (typeof realForm.requestSubmit === 'function') {
          realForm.requestSubmit();
        } else {
          realForm.submit();
        }
      }
    });

    window.Avalna.pdp.conversion.stickyAtc = {
      bar: bar,
      show: function () { bar.setAttribute('data-avalna-sticky-visible', 'true'); },
      hide: function () { bar.setAttribute('data-avalna-sticky-visible', 'false'); }
    };
  }

  /* ================================================================
     FEATURE 6: WhatsApp Inquiry Button (#24)
     ================================================================ */
  function avalnaInitWhatsappInquiry() {
    var el = document.getElementById('avalna-pdp-whatsapp-inquiry');
    if (!el) return;

    var phone = '917418668660';
    var message = el.getAttribute('data-avalna-message');

    if (!message) {
      var title = el.getAttribute('data-avalna-product-title') || '';
      var url = el.getAttribute('data-avalna-product-url') || window.location.href;
      message = 'Hi! I\'m interested in ' + title + '. Could you help me with more details? ' + url;
    }

    el.setAttribute('href', 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message));
    el.setAttribute('target', '_blank');
    el.setAttribute('rel', 'noopener noreferrer');

    var wrap = document.querySelector('[data-avalna-whatsapp-wrap]');
    if (wrap) {
      var avalnaWhatsappCollapse = function () {
        wrap.setAttribute('data-avalna-whatsapp-state', 'collapsed');
      };
      setTimeout(avalnaWhatsappCollapse, 4000);
      window.addEventListener('scroll', avalnaWhatsappCollapse, { passive: true, once: true });
    }

    window.Avalna.pdp.conversion.whatsappInquiry = {
      phone: phone,
      element: el
    };
  }

  /* ================================================================
     FEATURE 7: WhatsApp Share Button (#25)
     ================================================================ */
  function avalnaInitWhatsappShare() {
    var el = document.getElementById('avalna-pdp-whatsapp-share');
    if (!el) return;

    var title = el.getAttribute('data-avalna-product-title') || '';
    var url = el.getAttribute('data-avalna-product-url') || window.location.href;
    var text = 'Check out ' + title + ' on Avalna! ' + url;

    el.setAttribute('href', 'https://wa.me/?text=' + encodeURIComponent(text));
    el.setAttribute('target', '_blank');
    el.setAttribute('rel', 'noopener noreferrer');

    window.Avalna.pdp.conversion.whatsappShare = {
      element: el
    };
  }

  /* ================================================================
     FEATURE 8: Copy Link Button (#26)
     ================================================================ */
  function avalnaInitCopyLink() {
    var btn = document.getElementById('avalna-pdp-copy-link');
    if (!btn) return;

    var toast = document.getElementById('avalna-pdp-toast');
    var toastTimer = null;

    function avalnaShowToast() {
      if (!toast) return;
      toast.setAttribute('data-avalna-toast-visible', 'true');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.setAttribute('data-avalna-toast-visible', 'false');
      }, 2000);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = btn.getAttribute('data-avalna-clean-url') || window.location.href;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          avalnaShowToast();
        }).catch(function () {
          avalnaFallbackCopy(url);
        });
      } else {
        avalnaFallbackCopy(url);
      }
    });

    function avalnaFallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        avalnaShowToast();
      } catch (err) {
        console.warn('[Avalna] Copy to clipboard failed');
      }
      document.body.removeChild(ta);
    }

    window.Avalna.pdp.conversion.copyLink = {
      element: btn,
      showToast: avalnaShowToast
    };
  }

  /* ================================================================
     FEATURE 9: Savings Percentage Badge (#119)
     ================================================================ */
  function avalnaInitSavings() {
    var el = document.getElementById('avalna-pdp-savings');
    if (!el) return;

    // Parse variant data (shared with urgency)
    var dataEl = document.getElementById('avalna-pdp-variant-data');
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('[Avalna] Could not parse variant data for savings');
      }
    }

    function avalnaUpdateSavings(variant) {
      if (!variant) {
        el.hidden = true;
        return;
      }

      var found = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === variant.id) {
          found = variants[i];
          break;
        }
      }

      if (found && found.compare_at_price && found.compare_at_price > found.price) {
        var pct = Math.round((1 - found.price / found.compare_at_price) * 100);
        el.textContent = pct + '% off';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    // Initial state
    var initialVariantId = null;
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant) {
      initialVariantId = parseInt(urlVariant, 10);
    } else if (variants.length > 0) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          initialVariantId = variants[i].id;
          break;
        }
      }
      if (!initialVariantId && variants.length > 0) {
        initialVariantId = variants[0].id;
      }
    }

    if (initialVariantId) {
      avalnaUpdateSavings({ id: initialVariantId });
    }

    // Subscribe to variant changes
    avalnaSubscribeVariantChange(function (variant) {
      avalnaUpdateSavings(variant);
    });

    window.Avalna.pdp.conversion.savings = {
      update: avalnaUpdateSavings
    };
  }

  /* ================================================================
     INIT ON DOMContentLoaded
     ================================================================ */
  function avalnaInitConversion() {
    avalnaInitDelivery();
    avalnaInitUrgency();
    avalnaInitStickyAtc();
    avalnaInitWhatsappInquiry();
    avalnaInitWhatsappShare();
    avalnaInitCopyLink();
    avalnaInitSavings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaInitConversion);
  } else {
    avalnaInitConversion();
  }
})();
